module.exports = __webpack_public_path__ + "img/d061e74b5417f2c0b8387cf4deeba4cb.png";